import React from 'react'

import logoPNG from '../../images/old_tree_head.png'

const Logo = () => (
  <img style={{ width: 131, height: 40 }} src={logoPNG} alt="Old Tree logo" />
)

export default Logo
